import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  BsChevronRight,
  BsPlus,
  BsCircleFill,
  BsPersonBadgeFill,
} from "react-icons/bs";
import { Button } from "reactstrap";
import AddUpdateEmployee from "./AddUpdateEmployee";

const Joined = () => {
  const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);

  const openAddUpdateModel = () => {
    setShowAddUpdateModal(true);
    // setAction(null);
    // setUpdateModalData(null);
  };
  const onCloseAddUpdateModal = () => {
    setShowAddUpdateModal(false);
    // setAction(null);
    // setUpdateModalData(null);
  };

  const data = [
    {
      employee: "Employee 1",
      date: "2023-06-22",
      total: "100.00",
      task: "Task 1",
      finishedTasks: 5,
      totalPieceRate: "50.00",
    },
    {
      employee: "Employee 1",
      date: "2023-06-22",
      total: "100.00",
      task: "Task 1",
      finishedTasks: 5,
      totalPieceRate: "50.00",
    },
  ];

  return (
    <>
      {data.map((item, index) => (
        <>
          <div className="bg-gray-100 rounded-lg p-4 my-2">
            <Link className="flex items-center justify-between ">
              <div className="flex items-center">
                <BsPersonBadgeFill
                  className="items-center text-teal-600"
                  size={18}
                />
                <div className="ml-4">
                  <p className="text-gray-500 font-bold">Waseem Qasim</p>
                  <div className="flex gap-2">
                    <p className="text-gray-500 text-sm">Role: Admin</p>
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <Button color="link" className="text-teal-500 p-0">
                  <BsChevronRight size={24} />
                </Button>
              </div>
            </Link>
          </div>
        </>
      ))}

      {/* <span>Create a new invoice for this case</span> */}
      <div className="flex justify-center mt-3">
        <Button
          color="primary"
          onClick={openAddUpdateModel}
          className="flex items-center bg-teal-500 text-white px-4 py-2 rounded-md border-0 hover:bg-teal-600"
        >
          <BsPlus size={20} className="mr-2" />
          Add Employee
        </Button>
      </div>

      <AddUpdateEmployee
        show={showAddUpdateModal}
        onClosed={onCloseAddUpdateModal}
        toggle={(prev) => setShowAddUpdateModal(!prev)}
        // addPenalty={addPenalty}
        // rowData={rowData}
        // options={penaltyOptions}
        // loading={overlay}
      />
    </>
  );
};

export default Joined;

